<template>
  <section class="pt-14 md:pt-16 pb-10 md:pb-12">
  <SectionTitle
    title="Technical Skills"
    desc="In my career of coding/programming, I have worked with these technologies!" />

  <div
    class="mt-14 md:mt-16 [column-fill:_balance] sm:columns-1 sm:gap-6 lg:columns-2 lg:gap-8">
    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-blue-500 bg-blue-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="code"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Programming Languages
          </h1>
          <ul
            class="text-md text-gray-700 dark:text-gray-300 tracking-wide leading-relaxed font-medium list-disc pl-5">
            <li>PHP</li>
            <li>Go</li>
            <li>JavaScript</li>
            <li>TypeScript</li>
            <li>C/C++</li>
            <li>SQL</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-red-500 bg-red-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="command"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Libraries, Frameworks && CMS
          </h1>
          <ul
            class="text-md text-gray-700 dark:text-gray-300 tracking-wide leading-relaxed font-medium list-disc pl-5">
            <li>Laravel, Express.js</li>
            <li>Vue.js, React.js, React Native</li>
            <li>Expo</li>
            <li>FastAPI, Flask, Selenium</li>
            <li>AI Integration & AI Chatbots</li>
            <li>Tailwind CSS, SCSS</li>
            <li>WordPress Themes & Plugins Development</li>
            <li>Elementor & Beaver Builder Widget Development</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-violet-600 bg-violet-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="database"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Databases
          </h1>
          <ul
            class="text-md text-gray-700 dark:text-gray-300 tracking-wide leading-relaxed font-medium list-disc pl-5">
            <li>MongoDB</li>
            <li>MySQL</li>
            <li>PostgreSQL</li>
            <li>Redis</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-green-500 bg-green-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="tool"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Development Tools
          </h1>
          <ul class="text-md text-gray-700 dark:text-gray-300 list-disc pl-5">
            <li>BrightData (Web Scraping)</li>
            <li>Composer</li>
            <li>Docker</li>
            <li>Git (GitHub, GitLab)</li>
            <li>PHPUnit</li>
            <li>Postman</li>
            <li>REST API</li>
            <li>SSH</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-cyan-500 bg-cyan-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="git-branch"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            CI/CD
          </h1>
          <ul class="text-md text-gray-700 dark:text-gray-300 list-disc pl-5">
            <li>GitHub Actions</li>
            <li>Build and deployment workflows</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-orange-500 bg-orange-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="slack"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Deployment (Hosting + Cloud)
          </h1>
          <ul class="text-md text-gray-700 dark:text-gray-300 list-disc pl-5">
            <li>VPS</li>
            <li>Shared Hosting</li>
            <li>Cloudflare</li>
            <li>Firebase</li>
            <li>AWS(EC2, S3, RDS)</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="sm:break-inside-avoid rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-5 border-l-2 border-pink-500 bg-pink-50 dark:bg-ternary-dark">
      <div class="px-4 py-6 flex text-left items-start">
        <i
          data-feather="cpu"
          class="text-ternary-dark dark:text-white mr-5 w-10 h-10"></i>
        <div>
          <h1
            class="text-lg lg:text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
            Operating Systems
          </h1>
          <ul class="text-md text-gray-700 dark:text-gray-300 list-disc pl-5">
            <li>Linux (Debian based)</li>
            <li>Windows</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </section>
</template>

<script setup>
import SectionTitle from "@/components/reusable/SectionTitle.vue";
import feather from "feather-icons";
import { onMounted } from "vue";

onMounted(() => {
  feather.replace();
});
</script>

<style lang="scss" scoped></style>
